import styled from "@emotion/styled";
import { Search } from "@mui/icons-material";
import {
  Box,
  InputAdornment,
  Stack,
  Tab,
  Tabs,
  TextField
} from "@mui/material";
import { useTranslation } from "react-i18next";

const StyledTab = styled(Tab)`
  color: white;

  &.Mui-selected {
    border-radius: 5px;
    background-color: white;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export function EmployeesTableHeader({ tabValue, setTabValue, onSearch }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        color: "white",
        backgroundColor: "primary.main",
        py: 1,
        px: 2,
        borderRadius: "5px"
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Tabs
          value={tabValue}
          onChange={(event, value) => setTabValue(value)}
          aria-label="basic tabs example"
          indicatorColor=""
          variant="scrollable"
          scrollButtons="auto"
        >
          <StyledTab label={t("HR.HR.EmployeeList")} />
        </Tabs>
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            id="outlined-basic"
            variant="outlined"
            size="small"
            placeholder={t("denominations.denominations.search")}
            onChange={e => onSearch?.(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              ),
              sx: {
                px: 1,
                borderRadius: "50px",
                backgroundColor: "white",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none"
                },
                "&.Mui-focused": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                  }
                }
              }
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
